export const SINGLE_SERIES_FUND_CHART_OPTIONS = {
    chart: {
        animation: window.USER.authenticated,
    },
    plotOptions: {
        series: {
            animation: window.USER.authenticated,
        },
    },
    series: [{ type: 'area' }],
    xAxis: {
        tickAmount: 5,
    },
};
